import { PopularOption } from '@/entities/map'
import { AdditionalOption, BasicOption, RoomIcon } from '@/entities/room'
import { cn } from '@/shared/lib'

import { ADDITIONAL_OPTIONS, BASIC_OPTIONS, POPULAR_OPTIONS } from './option'
import { ExpandButton, useExpand } from '../../../lib/expand'
import { FilterType, useFilter } from '../../../model/filter'
import { Title, List, Item, SubTitle } from '../../common/layout'

const BASIC_OPTIONS_INITIAL_COUNT = 6

type Props = {
  type: FilterType
  ref: (element: HTMLDivElement) => void
  className?: string
  defaultExpanded: boolean
  selected: (value: PopularOption | BasicOption | AdditionalOption) => boolean
  onExpandClick: () => void
  onChange: ReturnType<typeof useFilter>['updateFilter']
}

export const OptionsInDialogView = ({
  type,
  ref,
  className,
  defaultExpanded,
  selected,
  onExpandClick,
  onChange,
}: Props) => {
  const { expanded, toggleExpand } = useExpand({
    defaultExpanded,
  })

  const basicOptionsList = expanded
    ? BASIC_OPTIONS
    : BASIC_OPTIONS.slice(0, BASIC_OPTIONS_INITIAL_COUNT)

  const handleExpandButtonClick = () => {
    toggleExpand()
    onExpandClick()
  }

  const handlePopularOptionChange = (value: PopularOption) => () => {
    onChange({ popularOptions: value })
  }

  const handleBasicOptionChange = (value: BasicOption) => () => {
    onChange({ basicOptions: value })
  }

  const handleAdditionalOptionChange = (value: AdditionalOption) => () => {
    onChange({ additionalOptions: value })
  }

  return (
    <div className={cn('space-y-3', className)} ref={ref}>
      <Title>옵션</Title>
      <div>
        <SubTitle>인기</SubTitle>
        <List>
          {POPULAR_OPTIONS.map(({ title, value, icon }) => (
            <Item
              key={title}
              type={type}
              selected={selected(value)}
              onClick={handlePopularOptionChange(value)}
              className="flex pl-3"
              startIcon={<RoomIcon name={icon} size={20} />}
            >
              <p className="ml-1 flex h-11 items-center justify-center whitespace-break-spaces">
                {title}
              </p>
            </Item>
          ))}
        </List>
      </div>
      <div>
        <SubTitle>기본</SubTitle>
        <List>
          {basicOptionsList.map(({ title, value, icon }) => (
            <Item
              key={title}
              type={type}
              selected={selected(value)}
              onClick={handleBasicOptionChange(value)}
              className="flex pl-3"
              startIcon={<RoomIcon name={icon} size={20} />}
            >
              <p className="ml-1 flex h-11 items-center justify-center whitespace-break-spaces">
                {title}
              </p>
            </Item>
          ))}
        </List>
      </div>
      {expanded && (
        <div>
          <SubTitle>추가</SubTitle>
          <List>
            {ADDITIONAL_OPTIONS.map(({ title, value, icon }) => (
              <Item
                key={title}
                type={type}
                selected={selected(value)}
                onClick={handleAdditionalOptionChange(value)}
                className="flex pl-3"
                startIcon={<RoomIcon name={icon} size={20} />}
              >
                <p className="ml-1 flex h-11 items-center justify-center whitespace-break-spaces">
                  {title}
                </p>
              </Item>
            ))}
          </List>
        </div>
      )}

      <div className="mt-4 flex justify-center">
        <ExpandButton expanded={expanded} onClick={handleExpandButtonClick} />
      </div>
    </div>
  )
}
